import { useAtomValue } from 'jotai'
import { createContext, useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { Header } from '@/components/Header.tsx'
import { ExchargeModal } from '@/pages/billing/components/RechargeModal.tsx'
import { atomLoginStatus, LoginStatus } from '@/stores/login'
import { useUserStore } from '@/stores/user'

import { Menu } from './Menu'

export interface Application {
  refresh: () => void
}

export const AppContext = createContext<Application>(null as any)

export function Layout() {
  const userStore = useUserStore()
  const [exchargeModalOpen, setExchargeModalOpen] = useState(false)

  const [refreshKey, setRefreshKey] = useState('')

  const loginStatus = useAtomValue(atomLoginStatus)

  useEffect(() => {
    userStore.getUserInfo()
    userStore.getOrder()
  }, [refreshKey])

  if (loginStatus !== LoginStatus.login) {
    return <Navigate to="login" replace />
  }

  const app: Application = {
    refresh: () => setRefreshKey(Math.random().toString(16)),
  }

  return (
    <AppContext.Provider value={app}>
      <div className="h-full flex flex-col overflow-hidden bg-[url(@/assets/images/bg-page.svg)] bg-cover">
        <Header setExchargeModalOpen={setExchargeModalOpen} />
        <main className="w-full flex-1 bg-cover bg-no-repeat bg-center pb-4 flex items-start overflow-auto">
          <div className="w-full flex flex-col gap-4 px-4 h-full">
            <Menu />

            <div className="min-w-[1400px] max-w-[1600px] w-full mx-auto flex-1 overflow-y-auto rounded-[24px] relative">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
      {exchargeModalOpen && (
        <ExchargeModal
          onOk={() => {
            setExchargeModalOpen(false)
            userStore.getUserInfo()
          }}
          onClose={() => {
            setExchargeModalOpen(false)
          }}
        />
      )}
    </AppContext.Provider>
  )
}
